import { connect } from 'react-redux';
import { goBack, push } from 'redux-first-history';
import LeaseSelectorPage from '@rental-manager/pages/Onboarding/LeaseSelectorPage/LeaseSelector.component';
import { DEFAULT_ERROR } from '@rental-manager/constants/NotificationConstants';
import { saveLeaseId, saveRentalProtectionFeature } from '@rental-manager/actions/OnboardingActions';
import { closeNotification, showModalNotification } from '@common/actions/NotificationActions';
import paths from '@rental-manager/pathsManifest';
import { pageFlows } from '@rental-manager/pages/Dashboard/SetupNewTermModal/pageFlows';
import { resetNewTermSettings, saveNewTermSettings } from '@rental-manager/actions/DashboardActions';
import FeaturePermissionTypes from '@rental-manager/constants/FeaturePermissionTypes';
import { logError } from '@zg-rentals/log-error';
import { ToggleFeatureWebApiHandler_toggleFeature } from '@zg-rentals/ts-rent-payment-client';

const mapStateToProps = (state, { propertyId }) => {
  const { leasesForProperty } = state.payments.landlord.onboarding[propertyId];
  const { userConfig } = state.payments.landlord.property;
  const { isRentGuaranteeEnabled } = userConfig;

  return {
    leasesForProperty,
    isRentGuaranteeEnabled,
    user: state.user,
    currentProperty: state.payments.landlord.property.listingDetails,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl, propertyId }) => ({
  onSubmitForRentalProtection: async (leaseId, warningForSelectedLease) => {
    try {
      await dispatch(closeNotification());
      await dispatch(saveLeaseId({ propertyId, leaseId }));
      if (leaseId === null) {
        return dispatch(
          push({
            pathname: baseUrl + paths.dashboard.areYouSurePage,
            state: { fromWhere: paths.dashboard.leaseSelectorPage },
          }),
        );
      } else if (warningForSelectedLease === 'ineligibleWarning') {
        return dispatch(push(baseUrl + paths.dashboard.ineligibleLeaseSelected));
      } else if (warningForSelectedLease === 'signingWarning') {
        return dispatch(push(baseUrl + paths.dashboard.unsignedLeaseWarning));
      } else {
        const featureName = FeaturePermissionTypes.RENT_GUARANTEE;
        await ToggleFeatureWebApiHandler_toggleFeature({ resourceId: propertyId, featureName, on: true });
        await dispatch(saveRentalProtectionFeature({ propertyId, rentGuarantee: true }));
        await dispatch(saveNewTermSettings({ currentPage: pageFlows.CurrentTenantEndDate }));
        return dispatch(push(baseUrl + paths.dashboard.setupNewTermPage));
      }
    } catch (err) {
      logError({ error: err });
      dispatch(showModalNotification(DEFAULT_ERROR));
      return { error: true };
    }
  },
  onBack: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(goBack())),
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(resetNewTermSettings()))
      .then(() => dispatch(push(baseUrl))),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeaseSelectorPage);
